import usePortManager from '../hooks/use-port-manager'
import usePriceManager from '../hooks/use-price-manager'
import React from 'react'
import axios from 'axios'
import useSettingsManager from '../hooks/use-settings-manager'
import PortInfo from '../order/PortInfo'
import SVGIcon from '../helpers/icons'

export function PortOverview2 (props) {
  const port_manager = usePortManager()
  const price_manager = usePriceManager()

  const [showall, setShowall] = React.useState(false)
  const [portAtts, setPortAtts] = React.useState(null)
  const fetchAtts = function () {

    let data = new FormData()
    data.append('action', 'nassau_port_config_portinfo')
    let port = JSON.stringify(port_manager.currentPort)
    data.append('port', port)
    axios.post(
      window.main_theme_objects.ajax_url,
      data
    )
      .then(function (response) {
        if (response.status !== 200) return
        if (typeof response.data !== 'object') return
        setPortAtts(response.data)
        setShowall(false)
      })
  }

  if (portAtts === null) fetchAtts()

  const changePort = function (port_id) {
    port_manager.changePort(port_id)
    setPortAtts(null)
    fetchAtts()
  }

  const settings_manager = useSettingsManager()
  const se_alle_specifikationer = settings_manager.getOtherSettings('view_all_specs_text', 'Se alle specifikationer')
  const anslaaet_leveringstidspunkt = settings_manager.getOtherSettings('eta_text', 'Anslået leveringstidspunkt: 4-5 Uger')
  const port_oversigt = settings_manager.getOtherSettings('port_overview_title', 'Port oversigt')
  const payment_price_text = settings_manager.getOtherSettings('payment_price_text', 'Pris')
  const ekskl_moms = settings_manager.getOtherSettings('payment_ekskl_moms_text', 'ekskl. moms')
  const inkl_moms = settings_manager.getOtherSettings('payment_inkl_moms_text', 'inkl. moms')
  return (
    <div>
      <h2>{port_oversigt}</h2>
      <p>{anslaaet_leveringstidspunkt}</p>
      <div className={'port-overview-nav'}>
        {port_manager.ports.map((port, index) => (
          <button
            key={index}
            onClick={() => changePort(port.port_id)}
            data-active={(port_manager.currentPort.port_id === port.port_id).toString()}
          >
            {port.name}
          </button>
        ))}
      </div>
      <div className={'port-overview__order'}>
        <PortInfo showall={showall} atts={portAtts}/>
      </div>
      <button
        className={'link-button link-button--icon'}
        onClick={() => setShowall(!showall)}
      >
        <SVGIcon
          type={showall ? 'close-circle' : 'add-alt'}
          fill={'#000'}
          className={'link-button__icon'}
        />
        {se_alle_specifikationer}
      </button>
    </div>
  )
}